/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NotificationListView } from '../models/NotificationListView';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class NotificationsService {
    /**
     * List in-app notifications for the current user
     * @param limit
     * @returns NotificationListView Newest notifications first
     * @throws ApiError
     */
    public static getAppNotificationsList(
        limit: number = 20,
    ): CancelablePromise<NotificationListView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/notifications',
            query: {
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Mark one notification as read
     * @param id
     * @returns any Marked read
     * @throws ApiError
     */
    public static postAppNotificationRead(
        id: string,
    ): CancelablePromise<{
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/notifications/{id}/read',
            path: {
                'id': id,
            },
            errors: {
                404: `Not found`,
            },
        });
    }
    /**
     * Mark all notifications as read for the current user
     * @returns any All marked read
     * @throws ApiError
     */
    public static postAppNotificationsReadAll(): CancelablePromise<{
        success?: boolean;
        markedCount?: number;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/notifications/read-all',
        });
    }
}
